import React, { Component } from 'react';
import { StyleSheet, View, Dimensions, ActivityIndicator, Image } from 'react-native';

import { COLOR, __WEB__ } from '../../constants/styles';

export default class ActivityOverlay extends Component {
  render() {
    let { height, width } = Dimensions.get('window');

    const { sizeToScreen, sizeToView } = this.props;
    let color = this.props.color || 'white';
    const noSpinner = this.props.noSpinner === true;
    const success = this.props.success === true;

    let sizeStyle = sizeToScreen ? { width, height } : sizeToView ? { bottom: 0, right: 0 } : {};

    return (
      <View style={[styles.loadingBackground, sizeStyle, this.props.overrideStyles]}>
        {!noSpinner &&
          !success && (
            <View style={{ paddingTop: height / 3 }}>
              <ActivityIndicator animating={true} size="large" color={color} />
            </View>
          )}
        {!!success && (
          <View style={styles.successContainer}>
            <View style={styles.successCircle}>
              <Image
                style={styles.successIcon}
                source={require('../../../resources/checkmark.png')}
              />
            </View>
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  loadingBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: __WEB__ ? COLOR.overlayLight : COLOR.overlay,
  },
  successContainer: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    // backgroundColor: 'pink'
  },
  successCircle: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    width: 50,
    height: 50,
    borderRadius: 25,
  },
  successIcon: {
    tintColor: COLOR.success,
  },
});
